export default __webpack_public_path__ + "static/getExtentionLogo-022caed18e31b5575c9a320e1b006272.svg";